/** BCP-47 locales supported for UI message catalogs. */
export type UiLocale = "en" | "pt-BR" | "es";

export const UI_LOCALES: UiLocale[] = ["en", "pt-BR", "es"];
export const DEFAULT_UI_LOCALE: UiLocale = "en";

/** Default learning pair for the seeded course (configurable per Course row). */
export const DEFAULT_TARGET_LOCALE = "pt-BR";
export const DEFAULT_NATIVE_LOCALE = "en";

/** @deprecated Use UiLocale - kept briefly for incremental migration. */
export type AppLocale = UiLocale;
